import { groupBy, isEmpty } from 'lodash'
import currency from 'currency.js'
import pluralize from 'pluralize'

export const ROWS_PER_PAGE = 10

export const parseFullName = ({ firstName, lastName }) => {
  if (!firstName && !lastName) return 'Foodsby User'

  return `${firstName} ${lastName}`
}

export const getMemberRole = isAdmin => (isAdmin ? 'Admin' : 'Member')

export const getMemberStatus = status => (status === 'CONFIRMED' ? 'Active' : 'Pending')

export const isTeamAdmin = (externalManagers, userId) =>
  externalManagers?.some(manager => manager.id === userId)

export const shouldDisplayInvoice = invoice =>
  invoice.status.toUpperCase() === 'FINAL' || invoice.status.toUpperCase() === 'PAID'

export const isInvoicePaid = status => status.toUpperCase() === 'PAID'
export const isInvoiceCanceled = status => status.toUpperCase() === 'CANCELED'

export const isRowSelected = (selectedMembers, member) =>
  selectedMembers.map(sm => sm.userId).includes(member.userId)

export const getSelectionDetails = (allMembers, rowsOnPage, selectedMembers) => {
  const allSelected = isAllSelected(allMembers, selectedMembers)
  const allPageSelected = isAllSelected(rowsOnPage, selectedMembers) || allSelected
  const someSelected = isSomeSelected(selectedMembers.length, allMembers.length) || allPageSelected
  const someSelectedOnPage = isSomeSelectedOnPage(rowsOnPage, selectedMembers)

  return {
    allSelected,
    allPageSelected,
    someSelected,
    someSelectedOnPage,
  }
}

export const formatOneWordEnumToPascal = word =>
  `${word.substring(0, 1).toUpperCase()}${word.substring(1).toLowerCase()}`

// Usage Type | Discount Amount | Member Count
export const formatProgramOverview = program =>
  `${formatOneWordEnumToPascal(program.usageType)}` +
  ' | ' +
  `${currency(program.discountAmountInPennies / 100, { formatWithSymbol: true }).format()}` +
  ' | ' +
  `${program.userIds.length} ${pluralize('Member', program.userIds.length)}`

export const isPaymentMethodRequiredForTeamPerks = (
  hasPaymentMethod,
  teamPaymentCollectionMethod,
) => !hasPaymentMethod && teamPaymentCollectionMethod === 'AUTOMATIC'

// ------------------------------------
// Private methods
// ------------------------------------
const isAllSelected = (rows, selectedMembers) => {
  if (isEmpty(rows) || isEmpty(selectedMembers)) {
    return false
  }

  const groupedRowsOnPage = groupBy(rows, 'userId')
  const groupedSelectedMembers = groupBy(selectedMembers, 'userId')

  return Object.keys(groupedRowsOnPage).every(rowKey => groupedSelectedMembers[rowKey])
}

const isSomeSelected = (numSelected, totalRows) => numSelected > 0 && numSelected < totalRows

const isSomeSelectedOnPage = (rowsOnPage, selectedMembers) => {
  const groupedRowsOnPage = groupBy(rowsOnPage, 'userId')
  const groupedSelectedMembers = groupBy(selectedMembers, 'userId')

  return Object.keys(groupedRowsOnPage).some(rowKey => groupedSelectedMembers[rowKey])
}
